import styled from 'styled-components';
import Colors from 'library/constants/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 32px 40px 48px;
  background: ${Colors.shade08};
  box-shadow: 0 2px 10px rgba(45, 49, 50, 0.08);
  border-radius: 4px;
  margin-top: 32px;
`;

export const List = styled.ul`
  background: ${Colors.shade08};
  display: flex;
  flex-direction: column;
  padding: 0;
  width: 96%;
`;

export const ListItem = styled.li`
  display: flex;
  flex-direction: row;
  background: ${Colors.shade07};
  margin: 6px 0;
  width: 100%;
  height: 40px;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
`;

export const Text = styled.p`
  font-size: 16px;
  color: ${Colors.shade01};
  margin: 0;
`;
